import { Component, OnInit, EventEmitter, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { Subject } from 'rxjs';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import * as $ from 'jquery';
import { CommonService } from 'src/app/services/common.service';
import { UserService } from 'src/app/services/user.service';
import { Module } from 'src/app/models/common';
import { AvailableProductsComponent } from '../../available-products/available-products.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-program-view-modal',
  templateUrl: './program-view-modal.component.html',
  styleUrls: ['./program-view-modal.component.scss']
})
export class ProgramViewModalComponent implements OnInit {

  formFields;
  programForm: UntypedFormGroup;
  strflag: string = null;
  content: any;
  heading: string;
  modulelist: any[] = [];
  productlist: any = [];
  MappedItems: any = [];
  action: Subject<any> = new Subject();
  isautocode: boolean = false;
  IsProductChecked: boolean = false;
  // IsButtonEnable: boolean = true;
  IsISTChecked: boolean = false;
  IsEAPChecked: boolean = false;
  ISGRANTSChecked: boolean = false;
  isreferenced: boolean = false;
  Pro_Id: any;
  Isdisabled: boolean = false;
  tooltipValue: any;
  tooltip: any
  @Input() public Content: any;
  ApplicationTypeList: any;



  constructor(
    private summaryService: AdministrationSummaryService,
    public modalRef: NgbActiveModal,
    private appFunctions: AppFunctionsService,
    private modalService: NgbModal,
    private commonservice: CommonService,
    private userService: UserService
  ) { }

  ngOnInit() {
    this.getModulesList();
    this.availableProducts();
    this.programForm = new UntypedFormGroup(
      {
        ID: new UntypedFormControl(""),
        CODE: new UntypedFormControl("", [Validators.required, Validators.maxLength(25)]),
        NAME: new UntypedFormControl("", [Validators.required, Validators.maxLength(100)]),
        DESCRIPTION: new UntypedFormControl("", [Validators.required, Validators.maxLength(255)]),
        IS_FUND_SUPPORT: new UntypedFormControl(false),
        IS_PRODUCT_SUPPORT: new UntypedFormControl(false),
        PROGRAM_ID: new UntypedFormControl("", [Validators.required]),
        PRODUCT_ID: new UntypedFormControl([], [Validators.required]),
        ACTIVECHECK: new UntypedFormControl(true),
        MAPPED_PRODUCTS: new UntypedFormControl([]),
        ApplicationType: new UntypedFormControl([]),
      });

    if (this.Content.heading == "Add") {
      this.programForm.controls['PRODUCT_ID'].disable();
    }
    else {
     
      this.GetEditData();
      if (this.Content.heading == "View") {
        this.programForm.disable();
        this.programForm.controls['PRODUCT_ID'].disable();
      }
    }
  }

  getApplicationtypes(RecordID: any, ModuleID: any) {
    this.commonservice.getAppTypesSpecificScreens("api/AdminProgram/GetProgramApplicationsTypes?RecordID=" + RecordID + "&moduleID=" + ModuleID).subscribe((result: any) => {
      if (result) {
        this.ApplicationTypeList = result;
        if (this.Content.heading == "Add") {
         this.programForm.controls["ApplicationType"].setValue([])

          let MappedApps = [];
          MappedApps= this.ApplicationTypeList.map(element => {
           return element.value;
          });
          this.programForm.controls["ApplicationType"].setValue(MappedApps);
        }
       
      }
      this.changeVal1("");
    });
  }

  changeVal($event) {
    let selectedProg = this.programForm.controls["PRODUCT_ID"].value;
    if (selectedProg != "" && selectedProg != undefined && selectedProg != null) {
      let productLabel = this.productlist.filter((item) => {
        return selectedProg.indexOf(item.value) > -1;
      })
      let labellist = [];
      productLabel.forEach((item) => {
        labellist.push(item.label);
      });
      this.tooltipValue = labellist.join(",");
    }
    else {
      this.tooltipValue = "";
    }

  }

  availableProducts() {
    this.summaryService.getSummaryData('api/AdminProgram/GetProductsAvaliable?RecordID=' + this.Content.content.id).subscribe((result) => {
      this.productlist = result;
      this.productlist.forEach((item: any) => {
        if (item.IsActive == false)
          item["icon"] = "ieg_inactive_record";
      })
    });
  }



  public setProgramOption(Pro_Id) {
    if (Pro_Id == 2) {
      this.IsISTChecked = true;
      this.IsEAPChecked = false;
      this.ISGRANTSChecked = false;
    }
    if (Pro_Id == 5) {
      this.IsEAPChecked = true;
      this.IsISTChecked = false;
      this.ISGRANTSChecked = false;
      this.programForm.controls["IS_PRODUCT_SUPPORT"].setValue(true);
      this.Isdisabled = true;
    }
    if (Pro_Id == 4) {
      this.ISGRANTSChecked = true;
      this.IsISTChecked = false;
      this.IsEAPChecked = false;
      this.programForm.controls["IS_FUND_SUPPORT"].setValue(true);
      this.programForm.controls["IS_PRODUCT_SUPPORT"].setValue(false);
      this.Isdisabled = true;
    }

  }

  public onOptionsSelected(event) {
    this.programForm.controls["ApplicationType"].setValue([])
    this.getApplicationtypes(this.Content.content.id, event.value);
    this.programForm.controls['IS_PRODUCT_SUPPORT'].enable();
    this.programForm.controls['IS_FUND_SUPPORT'].enable();
    if (event.value == "") {
      this.IsISTChecked = false;
      this.IsEAPChecked = false;
      this.ISGRANTSChecked = false;
      this.programForm.controls["IS_PRODUCT_SUPPORT"].setValue(false);
      this.programForm.controls["IS_FUND_SUPPORT"].setValue(false);
      this.programForm.controls['PRODUCT_ID'].setValue([]);
      this.programForm.controls['PRODUCT_ID'].disable();
    }
    if (event.value == "2") {
      this.programForm.controls['PRODUCT_ID'].setValue([]);
      this.IsISTChecked = true;
      this.IsEAPChecked = false;
      this.ISGRANTSChecked = false;
      this.programForm.controls["IS_PRODUCT_SUPPORT"].setValue(false);
      this.programForm.controls["IS_FUND_SUPPORT"].setValue(false);
      this.programForm.controls['PRODUCT_ID'].disable();

    }
    if (event.value == "5") {
      this.programForm.controls['PRODUCT_ID'].setValue([]);
      this.IsEAPChecked = true;
      this.IsISTChecked = false;
      this.ISGRANTSChecked = false;
      this.programForm.controls["IS_PRODUCT_SUPPORT"].setValue(true);
      this.Isdisabled = true;
      this.programForm.controls["IS_FUND_SUPPORT"].setValue(false);
      if (this.programForm.controls["IS_PRODUCT_SUPPORT"].value) {
        this.programForm.controls['PRODUCT_ID'].enable();
      }


    }
    if (event.value == "4") {
      this.programForm.controls['PRODUCT_ID'].setValue([]);
      this.ISGRANTSChecked = true;
      this.IsISTChecked = false;
      this.IsEAPChecked = false;
      this.programForm.controls["IS_FUND_SUPPORT"].setValue(true);
      this.programForm.controls["IS_FUND_SUPPORT"].disable();
      this.programForm.controls["IS_PRODUCT_SUPPORT"].setValue(false);
      this.programForm.controls['PRODUCT_ID'].disable();

    }

  }

  getModulesList(): void {
    this.summaryService.getModuleList('api/common/getmoduleslist').subscribe((result) => {
      this.modulelist = result;
      this.modulelist = [{ label: "Select", value: "" }].concat(this.modulelist);
    });
  }


  IsproductAvaliable(event) {
    if (this.programForm.controls["IS_PRODUCT_SUPPORT"].value && this.isreferenced == false && this.Content.heading != "View") {
      this.programForm.controls['PRODUCT_ID'].enable();
    }
    if (!this.programForm.controls["IS_PRODUCT_SUPPORT"].value) {
      this.programForm.controls['PRODUCT_ID'].setValue([]);
      this.programForm.controls['PRODUCT_ID'].disable();
    }
  }
  
  changeVal1(event) {
    setTimeout(() => {
      let selectedProg: any;
      selectedProg = this.programForm.controls["ApplicationType"].value;
      if (selectedProg != "" && selectedProg != undefined && selectedProg != null) {
        let TypeLabel = this.ApplicationTypeList.filter((item) => {
          return selectedProg.indexOf(item.value) > -1;
        })
        let labellist = [];
        TypeLabel.forEach((item) => {
          labellist.push(item.label);
        });
        this.tooltip = labellist.join(",");
      }
      else {
        this.tooltip = "";
      }
    }, 200);
  }

  GetEditData(): void {
    this.summaryService.getRecord('api/AdminProgram/Edit?RecordID=' + this.Content.content.id).subscribe((summary: any) => {
      if (summary.Status == 0) {
        let productIds = [];
        if (summary.Data["MAPPED_PRODUCTS"] != undefined && summary.Data["MAPPED_PRODUCTS"] != null && summary.Data["MAPPED_PRODUCTS"]!="") {
          productIds = summary.Data["MAPPED_PRODUCTS"].split("|");
        }
        let applicationIds = [];
        if (summary.Data["MappedAppTypesIDs"] != undefined && summary.Data["MappedAppTypesIDs"] != null && summary.Data["MappedAppTypesIDs"] != "") {
          applicationIds = summary.Data["MappedAppTypesIDs"].split("|");
        }
        this.programForm.patchValue({
          ID: summary.Data["ID"],
          CODE: summary.Data["CODE"],
          NAME: summary.Data["NAME"],
          ACTIVECHECK: summary.Data["RECORD_STATE"] == 1 ? true : false,
          DESCRIPTION: summary.Data["DESCRIPTION"],
          IS_FUND_SUPPORT: summary.Data["IS_FUND_SUPPORT"],
          IS_PRODUCT_SUPPORT: summary.Data["IS_PRODUCT_SUPPORT"],
          PRODUCT_ID: productIds,
          PROGRAM_ID: summary.Data["PROGRAM_ID"],
          ApplicationType: applicationIds,
        });
        this.getApplicationtypes(this.Content.content.id,summary.Data["PROGRAM_ID"]);
        if (this.Content.heading == "View") {
          this.programForm.disable();
        }
        else
        {
          if (summary.Data["isrefered"] == true) {
            this.programForm.controls['PROGRAM_ID'].disable();
            this.programForm.controls['PRODUCT_ID'].disable();
            this.programForm.controls['IS_FUND_SUPPORT'].disable();
            this.programForm.controls['IS_PRODUCT_SUPPORT'].disable();
  
            this.isreferenced = true;
          }
          if (summary.Data["PROGRAM_ID"] == "4") {
            this.programForm.controls['IS_FUND_SUPPORT'].disable();
          }
        }
        this.setProgramOption(this.programForm.controls['PROGRAM_ID'].value);
       
      }
      else {
        this.commonservice.ValidationBanner(summary.Message);
      }
    this.IsproductAvaliable("");

    });
  }

  SaveProgram() {

    if (this.validateControls()) {
      var formDate = this.programForm.getRawValue();
      formDate.RECORD_STATE = this.programForm.controls["ACTIVECHECK"].value ? 1 : 0;
      formDate.MAPPED_PRODUCTS = formDate.PRODUCT_ID;
      formDate.NAME = formDate.NAME == null ? null : formDate.NAME == undefined ? undefined : formDate.NAME.trim();
      if (formDate.PRODUCT_ID != null && formDate.PRODUCT_ID != "" && formDate.PRODUCT_ID != undefined && formDate.PRODUCT_ID.length > 0) {
        let selectedids = formDate.MAPPED_PRODUCTS.join(",");
        let tempList = this.productlist.filter((item) => {
          return selectedids.indexOf(item.value) > -1;
        });
        tempList.forEach((obj, index) => {
          if (index == 0) {
            formDate.MAPPED_PRODUCTS = obj.value;
            formDate.MAPPEDPRODUCTNAME = obj.label;
          }
          else {
            formDate.MAPPED_PRODUCTS = formDate.MAPPED_PRODUCTS + "|" + obj.value;
            formDate.MAPPEDPRODUCTNAME = formDate.MAPPEDPRODUCTNAME + "," + obj.label;
          }
        });
      }
      else {
        formDate.MAPPED_PRODUCTS = "";
      }
      if (formDate.ApplicationType != null && formDate.ApplicationType != "" && formDate.ApplicationType != undefined) {
        formDate['MappedAppTypesIDs'] = formDate.ApplicationType.join(",");
        let tempList = this.ApplicationTypeList.filter((item) => {
          return formDate['MappedAppTypesIDs'].indexOf(item.value) > -1;
        });

        tempList.forEach((obj, index) => {
          if (index == 0)
            formDate['MappedAppTypesNames'] = obj.label;
          else
            formDate['MappedAppTypesNames'] = formDate['MappedAppTypesNames'] + "," + obj.label;
        });
      }

      if (this.Content.heading == "Add") {
        formDate["ID"] = this.Content.content.id;
        this.summaryService.Insert('api/AdminProgram/Insert', formDate).subscribe(summary => {
          if (summary.Status == 0) {
            this.modalRef.close();
            this.commonservice.SuccessBanner(summary.Message);
            this.programForm.controls["ID"].setValue(this.Content.content.id);
          }
          else {
            this.commonservice.ValidationBanner(summary.Message);
          }
        });
      }
      else {
        this.summaryService.Insert('api/AdminProgram/Update', formDate).subscribe(summary => {
          if (summary.Status == 0) {
            // this.action.next();
            this.modalRef.close();
            this.commonservice.SuccessBanner(summary.Message);
          }
          else {
            this.commonservice.ValidationBanner(summary.Message);
          }
        });
      }
    }

  }
  validateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.programForm.getRawValue();
    if (formData.NAME === null || formData.NAME === "" || formData.NAME === undefined) {
      $("#NAME").addClass("ng-touched ng-invalid validate-error");
      $("#NAME").removeClass("ng-untouched ng-valid");
      message += "Please enter Program Category<br/>";
      isValid = false;
    } else if ((formData.NAME != null && formData.NAME != undefined) && formData.NAME.trim() == "") {
      $("#NAME").addClass("ng-touched ng-invalid validate-error");
      $("#NAME").removeClass("ng-untouched ng-valid");
      message += "Please enter Program Category<br/>";
      isValid = false;
    }
    else {
      $("#NAME").addClass("ng-untouched ng-valid");
      $("#NAME").removeClass("ng-touched ng-invalid validate-error");
    }

    if (this.programForm.controls["PROGRAM_ID"].value == null || this.programForm.controls["PROGRAM_ID"].value == undefined || this.programForm.controls["PROGRAM_ID"].value == "") {
      $("#MODULE_ID").addClass("ng-touched ng-invalid validate-error");
      $("#MODULE_ID").removeClass("ng-untouched ng-valid");
      message += "Please select Program<br/>";
      isValid = false;
    }
    else {
      if (this.programForm.controls["IS_PRODUCT_SUPPORT"].value) {
        if (formData.PRODUCT_ID == null || formData.PRODUCT_ID == "") {
          {
            // if (this.MappedItems == null || this.MappedItems == "") {
            $("#PRODUCT_ID").addClass("ng-touched ng-invalid validate-error");
            $("#PRODUCT_ID").removeClass("ng-untouched ng-valid");
            message += "Please select Avaliable Products<br/>";
            isValid = false;
            //  }
          }
        }
      }

      if (this.programForm.controls["ApplicationType"].value == null || this.programForm.controls["ApplicationType"].value.length == 0) {
        $("#ApplicationType").addClass("ng-touched ng-invalid validate-error");
        $("#ApplicationType").removeClass("ng-untouched ng-valid");
        message += "Please select Application Type<br/>";
        isValid = false;
      }
      else if (this.programForm.controls["ApplicationType"].value != null && this.programForm.controls["ApplicationType"].value.length > 0) {
        let selectedIDs = this.programForm.controls["ApplicationType"].value.join(",")
        let InactiveAvilable = this.ApplicationTypeList.filter((item) => {
          return (selectedIDs.indexOf(item.value) > -1 && item.IsActive == false);
        })[0];
        if (InactiveAvilable != undefined && InactiveAvilable != null) {
          $("#ApplicationType").addClass("ng-touched ng-invalid validate-error");
          $("#ApplicationType").removeClass("ng-untouched ng-valid");
          message += "Please remove inactive application type to save the details<br/>";
          isValid = false;
        }
      }
      if (formData.IS_FUND_SUPPORT === false && formData.IS_PRODUCT_SUPPORT === false) {
        $("#IS_FUND_SUPPORT").addClass("ng-touched ng-invalid validate-error");
        $("#IS_FUND_SUPPORT").removeClass("ng-untouched ng-valid");
        message += "Please select at least program type<br/>";
        isValid = false;
      } else {
        $("#IS_FUND_SUPPORT").addClass("ng-untouched ng-valid");
        $("#IS_FUND_SUPPORT").removeClass("ng-touched ng-invalid validate-error");
      }

    }

    if (!isValid)
      this.commonservice.ValidationBanner(message);
    return isValid;
  }
}
